import { render, staticRenderFns } from "./AsyncSidebar.vue?vue&type=template&id=0e255516&"
import script from "./AsyncSidebar.vue?vue&type=script&lang=js&"
export * from "./AsyncSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports